import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Text } from '../../Atoms';
import { CardTitle } from './CardTitle';
import { CardSubTitle } from './CardSubTitle';
export var StyledCardLight = function StyledCardLight(props) {
  return "\n    background: ".concat(props.theme.components.card.lightBackground, ";\n    color: ").concat(props.theme.components.card.lightColor, ";\n\n    ").concat(Text.Styles.StyledText, " {\n        color: ").concat(props.theme.components.card.lightColor, ";\n    }\n\n    ").concat(CardTitle.Styles.StyledCardTitle, ", ").concat(CardSubTitle.Styles.StyledCardSubTitle, " {\n        color: ").concat(props.theme.components.card.titleLightColor, ";\n    }\n");
};
export var StyledCardDark = function StyledCardDark(props) {
  return "\n    background: ".concat(props.theme.components.card.darkBackground, ";\n    color: ").concat(props.theme.components.card.darkColor, ";\n\n    ").concat(Text.Styles.StyledText, " {\n        color: ").concat(props.theme.components.card.darkColor, ";\n    }\n");
};
export var StyledCard = styled.div(_templateObject(), function (props) {
  return "\n        position: relative;\n        padding: ".concat(props.theme.components.card.padding, ";\n        width: ").concat(props.width, ";\n        max-width: 100%;\n        border-radius: 5px;\n        box-shadow: ").concat(props.shadow ? props.theme.components.card.shadow : '', ";\n        box-sizing: border-box;\n\n        ").concat(props.light ? StyledCardLight(props) : StyledCardDark(props), "\n    ");
});